import React from 'react'
import {
  StyledFormikInputField,
  Container,
  InputLabel,
} from './AccountDetailsUserInfo.styles'
import { Field, ErrorMessage } from 'formik'

const AccountDetailsUserInfo = props => {
  const { names, ErrorContainer, isSSO, values } = props
  const isRequiredLabel = !isSSO ? '*' : ''
  const attributeHelper = (name, attribute) => {
    if (name === 'email') {
      if (attribute === 'label') return 'Email Address'
      if (attribute === 'type') return 'email'
      if (attribute === 'value') return values[0]
      if (attribute === 'disabled') return true
    }
    if (name === 'firstName') {
      if (attribute === 'label') return `First Name${isRequiredLabel}`
      if (attribute === 'type') return 'text'
      if (attribute === 'value') return values[1]
      if (attribute === 'disabled') return isSSO
    }
    if (name === 'lastName') {
      if (attribute === 'label') return `Last Name${isRequiredLabel}`
      if (attribute === 'type') return 'text'
      if (attribute === 'value') return values[2]
      if (attribute === 'disabled') return isSSO
    }
  }

  return (
    <Container>
      {names.map(name => (
        <StyledFormikInputField key={name}>
          <InputLabel>
            {attributeHelper(name, 'label')}
            <ErrorContainer>
              <ErrorMessage name={name} />
            </ErrorContainer>
          </InputLabel>
          <Field
            disabled={attributeHelper(name, 'disabled')}
            name={name}
            type={attributeHelper(name, 'type')}
            value={attributeHelper(name, 'value')}
          />
        </StyledFormikInputField>
      ))}
    </Container>
  )
}

export default AccountDetailsUserInfo



// WEBPACK FOOTER //
// ./src/components/AccountDetailsUserInfo/AccountDetailsUserInfo.js